import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface SkillCollectionFileNode {
  type: "file";
  id: number;
  path: string;
  name: string;
}

export interface SkillCollectionFolderNode {
  type: "folder";
  name: string;
  path: string;
  children: SkillCollectionTreeNode[];
}

export type SkillCollectionTreeNode = SkillCollectionFileNode | SkillCollectionFolderNode;

interface ListSkillCollectionFilesResponse {
  success: boolean;
  files: SkillCollectionTreeNode[];
}

export const useListSkillCollectionFiles = (
  workspaceId: number | null,
  collectionId: string | null,
) => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useQuery({
    queryKey: ["skill-collection-files", workspaceId, collectionId],
    queryFn: async (): Promise<ListSkillCollectionFilesResponse> => {
      if (!workspaceId || !collectionId) {
        return { success: true, files: [] };
      }
      const res = await fetch(ENDPOINTS.skill_collections.files(workspaceId, collectionId), {
        headers: jsonAuthHeaders(userToken),
      });
      return handleResponse(res);
    },
    enabled: !!workspaceId && !!collectionId && !!userToken,
  });
};
